import { Copy, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export function CopyButton({ value, testId, textColor }) {
  const [copied, setCopied] = useState(false);

  const onCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      toast.success(`Copied ${value}`);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      toast.error("Copy failed");
    }
  };

  return (
    <button
      data-testid={testId}
      onClick={onCopy}
      aria-label={`Copy ${value}`}
      style={textColor ? { color: textColor } : undefined}
      className="inline-flex items-center justify-center h-7 w-7 hover:bg-black/10 dark:hover:bg-white/10 transition-colors"
    >
      {copied ? (
        <Check className="h-3.5 w-3.5" strokeWidth={1.8} />
      ) : (
        <Copy className="h-3.5 w-3.5" strokeWidth={1.5} />
      )}
    </button>
  );
}
